<div class="container">
  <div
    class="container-content mb-58"
    *ngFor="let templateGroup of templateGroups"
  >
    <span class="subtitle">
      {{ templateGroup.title }}
    </span>

    <div class="content-list list">
      <ng-container
        *ngIf="templateGroup.template === DialogEmailTypeEnum.Transfer"
      >
        <div class="repasse mt-16">
          <app-header-list [headerItems]="headerRepasse">
            <div button class="d-flex justify-flex-end flex-2">
              <button type="button" class="btn" (click)="openAddEmailDialog()">
                <span class="btn-label d-flex justify-center align-center">
                  <app-svg-icon
                    src="../../../../assets/icons/vector-comissao.svg"
                    color="white"
                    width="12px"
                    height="12px"
                    class="mr-10"
                  >
                  </app-svg-icon>
                  <span>Cadastrar</span>
                </span>
              </button>
            </div>
          </app-header-list>
          <div
            class="repasse-card"
            *ngFor="let repasseTemplate of repasseTemplates; let index = index"
          >
            <app-card-configuracoes
              [templateData]="repasseTemplate"
              [cardType]="DialogEmailTypeEnum.Transfer"
              (deleteParameterEvent)="deleteParameter(index)"
            ></app-card-configuracoes>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="templateGroup.template === DialogEmailTypeEnum.Invoice"
      >
        <div class="faturamento mt-16">
          <app-header-list [headerItems]="headerFaturamento"> </app-header-list>
          <div
            class="faturamento-card"
            *ngFor="let faturamentoTemplate of faturamentoTemplates"
          >
            <app-card-configuracoes
              [templateData]="faturamentoTemplate"
              [cardType]="DialogEmailTypeEnum.Invoice"
            ></app-card-configuracoes>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
